// extracted by mini-css-extract-plugin
module.exports = {"ldFacebook":"Spinner_ldFacebook__01FUH"};